module.exports = __webpack_public_path__ + "static/guardian_of_faith-6717719cbebcf20eab5084c312d013b5.jpg";